import { render, staticRenderFns } from "./CarneDigital.vue?vue&type=template&id=1a92a3b0"
import script from "./CarneDigital.vue?vue&type=script&lang=js"
export * from "./CarneDigital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports